import { SiriusBaseComponent} from 'sirius-framework';
import { ViewChild, Input, ElementRef, Component } from '@angular/core'
import { LoginModel, SharedModel, CaptchaModel, DocumentViewModelList } from '../../../../app/shared/models/shared.model';
import { CommonService } from '../../../../app/shared/service/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms'; 
import { CustomValidators } from './../../../shared/validators/custom-validators'; 
import { TransactionNames } from '../../../../app/shared/constants/constants'
import { PopupService } from './../../../popup/informationPopup/popup.service';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged'; 
import { DomSanitizer } from '@angular/platform-browser'; 
import { MessageShowComponent } from '../../../popup/message-show/message-show.component';
import { Router } from '@angular/router';  

@Component({
  selector: 'login-form-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent extends SiriusBaseComponent<LoginModel>{

  wrongSmsKey: boolean;
  wrongSmsErrorMessage: string;
  @Input() appType: string;
  @ViewChild('SmsTextBox') smsTextBox: any;
  @ViewChild('CaptchaTextBox') captchaTextBox: any;

  logTheModel: boolean = true;
  isSubmitted: boolean = false;
  captchaTextValue: string;
  birthDateValue: string;

  isActMemberControlFormActive: boolean = false;
  isNewMemberFormActive: boolean = false;
  isLoginFormActive: boolean = true;
  isCaptchaActive: boolean = false;
  isSmsFormActive: boolean = false;
  isSmsReSendBtnActive: boolean = false;
  isOpenInfoPopup: boolean;


  IsLocalOrTestOrPreProd: boolean;
  public maskDate = SharedModel.dTarihiMask;
  public maskTel = SharedModel.cepTelMask;
  maskRefNo = [/[qQ]/, /[nN]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  action: any;

  documentOpen: boolean = false;
  openDocumentId: string;
  docTitle: string;
  openDocumentList: Array<string>;
  isOpenDocument1: boolean = false;
  isOpenDocument2: boolean = false;

  popUpMessage: string;
  popUpTitle: string = "Uyarı";

  switchContent: string = '';
  isTermofUseOk: boolean = false;

  actMemberControlForm: FormGroup;
  newMemberForm: FormGroup;
  loginForm: FormGroup;
  @ViewChild('loginCaptcha') loginCaptcha: any;
  @ViewChild('messagePopup') messagePopup: MessageShowComponent;

  actAsTst: boolean = false;
  useKps: boolean = true;
  showTst: boolean = false;
  isBirthDayActive: boolean = false;
  kvkkTitle: string;
  kvkkMessage: string;

  constructor(private fb: FormBuilder, private commonService: CommonService,
    private infoPopupService: PopupService, private domSanitizer: DomSanitizer,
    private elementRef: ElementRef, private router: Router) {
    super();
    this.commonService.navigationService = this.navigationService;
    this.commonService.sessionService = this.sessionService;
    this.commonService.dataService = this.dataService;
    //this.commonService.resourceService = this.resourceService; 

    this.resetModel();

    this.loginForm = this.fb.group({
      identity: new FormControl('', [Validators.maxLength(11), Validators.minLength(11), CustomValidators.isTckn]),
      telephoneNumber: new FormControl('', [CustomValidators.isTelephoneNumber]),
      checkbox: new FormControl(''),
      checkbox2: new FormControl('') //FORTEST
    }
    );

    this.newMemberForm = this.fb.group({
      memberName: new FormControl('', [Validators.maxLength(50), Validators.minLength(2)]),
      memberSurname: new FormControl('', [Validators.maxLength(50), Validators.minLength(2)]),
      birthdate: new FormControl('', [CustomValidators.isDate]),
      checkbox: new FormControl('')
    }
    );

    this.actMemberControlForm = this.fb.group({
      referansNo: new FormControl('', [Validators.maxLength(17), Validators.minLength(16)]),
      plateNumber: new FormControl('', [Validators.maxLength(50), Validators.minLength(6)])
    }
    );

    let isUserLoggedIn = this.commonService.loggedinStatus;
    this.popUpMessage = this.commonService.getGeneralErrorMessage();
    let isInner = false;

    let isLvResponse = this.commonService.isLv();
    isLvResponse.toPromise().then((result) => {
      this.showTst = !result.IsLive;
      if (result.IsLive) {
        this.actAsTst = false;
        this.useKps = true;
      }
      else {
        this.actAsTst = true;
        this.useKps = false;
      }
    });

    let updResPonse = this.commonService.updPhnrTnPk();
    updResPonse.toPromise().then((result) => {
      isInner = result.IsOk;
      if (isInner) {
        this.sessionService.authenticated = true
        this.sessionService.forceTimeout = false;
        let idInput = this.loginForm.get('identity');
        idInput.setValue(result.Up1);
        idInput.disable();
        let telInput = this.loginForm.get('telephoneNumber');
        telInput.clearValidators();
        telInput.setValue(result.Up2);
        this.formSubmit(null);
      }
    }).then(() => {
      if (!isInner) {
        if (isUserLoggedIn == true)
          this.commonService.logOutAtLogin();
        this.sessionService.authenticated = false
        this.sessionService.forceTimeout = true;
      }
    })

  }

  OnInit() {
   
    this.model.SmsSent = false;
    this.model.SMSKey = null;
    this.showLoginForm();
    this.commonService.setEftBankList(this.dataService);
    this.commonService.notAtLoginPage.next(false);
    let birthDayActiveValue = this.resourceService.getResource("askbirthday");
    if (birthDayActiveValue == "1") {
      this.isBirthDayActive = true;
    }
    else {
      this.newMemberForm.controls['birthdate'].setValue('01/01/2000');
    }
  }

  ngAfterView() {
  }

  ngAfterViewInit() {

  }

  checkBoxClicked() {
    this.actAsTst = !this.actAsTst;
  }

  checkBoxClicked2() {
    this.useKps = !this.useKps;
  }

  onSwitchChanged(e: boolean) {
    this.isTermofUseOk = e;
  }

  onMessageAccepted() {
    if (this.model.ErrorCode == 99) {
      this.callLogOut();
    }
  }

  clickCepTel() {
    if (this.loginForm.get('telephoneNumber').value || this.loginForm.get('telephoneNumber').value === "") {
      this.loginForm.get('telephoneNumber').setValue(5);
    }
  }

  public formSubmit(e: Event) {
    if(e!=null)
      e.preventDefault();
    try {
      if (this.isSubmitted)
        return;

      // this.commonService.showLoadingAnimate.next(true); 
      this.controllerToModel();

      if (this.loginForm.valid) {

        this.isSubmitted = true;
        this.model.TcknDenendi = true;
        this.model.ActAsTst = this.actAsTst;
        this.model.UseKps = this.useKps;
        this.model.LoginSuccess = false;
        this.model.ErrorCode = -1;
        this.model.IsActUserControlOk = false;
        this.model.IsRegistered = false;
        this.model.TcknDenendi = false;
        this.model.BirthDate = "";
        this.model.NeedExtraInfo = false;

        var promise = this.commonService.startCaptchaValidation(this.dataService, this.model);
        promise.then((result) => {
          this.isSubmitted = false;
          this.model.ShowCaptcha = result.ShowCaptcha;
          this.model.ErrorCode = result.ErrorCode;
          this.model.ErrorMessage = result.ErrorMessage;

          if (this.showErrorMessages()) {
            return;
          }

          //this.commonService.getDocumentList();
          //if (this.model.ShowCaptcha == SharedModel.str1) {
          //  this.showCaptchaForm();
          //}
          //else {
          //  this.showSMSForm();
          //  this.startTimer();
          //}

          let model = new DocumentViewModelList();
          let promise = this.dataService.post<DocumentViewModelList>("GetDocumentList", model).toPromise();
          promise.then((result) => {
            this.commonService.publicDocList = <DocumentViewModelList>result;
            if (this.model.ShowCaptcha == SharedModel.str1) {
              this.showCaptchaForm();
            }
            else {
              this.showSMSForm();
              this.startTimer();
            }
          });



        });
      }
    } catch {
      this.isSubmitted = false;
      this.messagePopup.showPopup();
    }


  }

  public validateCaptchEvent(e: Event) {
    e.preventDefault();
    try {
      if (this.isCaptchaActive && this.captchaTextValue.length == 6) {

        if (this.isSubmitted)
          return;

        this.isSubmitted = true;

        this.model.CaptchaModel = new CaptchaModel();
        this.model.CaptchaModel.CaptchaName = 'Captcha';
        this.model.CaptchaModel.CaptchaValue = this.captchaTextValue.toUpperCase();

        var captchaPromise = this.commonService.validateCaptcha(this.dataService, this.model);
        captchaPromise.toPromise().then((result) => {
          this.isSubmitted = false;
          this.model.CaptchaModel.CaptchaValidated = result.CaptchaValidated;

          if (!this.model.CaptchaModel.CaptchaValidated) {

            if (result.ErrorCode == 1) {
              this.messagePopup.showPopup();
              return;
            }

            this.model.WrongCaptchaEntry = true;
            this.loginCaptcha.refresh();
            this.captchaTextValue = '';

            var promise = this.commonService.startCaptchaValidation(this.dataService, this.model);
            promise.then((result) => {
              this.model.ErrorCode = result.ErrorCode;
              this.model.ErrorMessage = result.ErrorMessage;
              if (this.showErrorMessages()) return;
            });

            return;
          }
          else {
            this.showSMSForm();
            this.model.WrongCaptchaEntry = false;
            this.startTimer();
          }
        });
      }
      else
        this.messagePopup.showPopup();
    }
    catch {
      this.isSubmitted = false;
      this.messagePopup.showPopup();
    }
  }

  public validateSMSEvent(e: Event) {
    e.preventDefault();
    try {
      if (this.model.SMSKey.length > 3) {

        if (this.isSubmitted)
          return;

        this.isSubmitted = true;

        var promise = this.commonService.applyLoginWs(this.dataService, this.model);
        promise.then((result) => {
          this.isSubmitted = false;
          this.model.LoginSuccess = result.LoginSuccess;
          this.model.SmsSent = result.SmsSent;
          this.model.ErrorCode = result.ErrorCode;
          this.model.ErrorMessage = result.ErrorMessage;
          this.model.IsRegistered = result.IsRegistered;
          this.model.NeedExtraInfo = result.NeedExtraInfo;
          this.model.MemberName = result.MemberName;
          this.model.MemberSurname = result.MemberSurname;

          if (!this.showErrorMessages()) {
            if (this.model.SmsSent) {
              if (this.model.LoginSuccess) {
                if (this.model.IsRegistered) {
                  if (this.model.NeedExtraInfo) {
                    this.showActMemberControlForm();
                  }
                  else {
                    this.sessionService.authenticated = true;
                    this.sessionService.forceTimeout = false;
                    this.commonService.isLoggedin.next(true);
                    this.commonService.loggedUserName.next(this.model.MemberName + " " + this.model.MemberSurname);
                    if (result.GetName)
                      this.commonService.StartTransaction('AccountProfileTransaction', SharedModel.PageName_Preferences);
                    else
                      this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
                  }
                }
                else {
                  this.showNewMemberForm();

                }
              }
              else {
                this.showErrorMessages();
              }
            }
            else {
              this.model.SMSKey = "";
            }
          }
        });
      }
      else
        this.messagePopup.showPopup();
    }
    catch {
      this.isSubmitted = false;
      this.messagePopup.showPopup();
    }
  }

  public newMemberFormSubmit(e: Event) {
    e.preventDefault();
    try {
      this.controllerToModel2();

      if (this.model.MemberName.length < 2 || this.model.MemberSurname.length < 2) {
        this.messagePopup.showPopup();
        return;
      }

      if (!this.isOpenDocument1 || !this.isOpenDocument2) {
        this.showMessagePopUp('Ön Bilgilendirme Formu ve Kullanım Sözleşmesine dair detayları görüntülemek için lütfen linkleri ayrı ayrı tıklayınız ve okuyup onaylayınız.');
        return;
      }

      if (!this.isTermofUseOk) {
        this.showMessagePopUp('Lütfen Ön Bilgilendirme Formu ve Kullanım Sözleşmesini okuyup onayladığınızı belirtiniz.');
        return;
      }

      if (this.isSubmitted)
        return;


      if (this.newMemberForm.valid) {
        this.isSubmitted = true;
        var promise = this.commonService.recordNewMember(this.dataService, this.model);
        promise.toPromise().then((result) => {
          this.isSubmitted = false;
          this.model.ErrorCode = result.ErrorCode;
          this.model.ErrorMessage = result.ErrorMessage;
          this.model.IsRegistered = result.IsRegistered;
          this.model.LoginSuccess = result.LoginSuccess;
          this.model.MemberName = result.MemberName;
          this.model.MemberSurname = result.MemberSurname;

          if (!this.showErrorMessages()) {
            if (this.model.LoginSuccess && this.model.IsRegistered) {
              this.sessionService.authenticated = true;
              this.sessionService.forceTimeout = false;
              this.commonService.isLoggedin.next(true);
              this.commonService.loggedUserName.next(this.model.MemberName + " " + this.model.MemberSurname);
              this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
            }
            else {
              this.showErrorMessages();
            }
          }
        });
      }
    } catch (e) {
      this.isSubmitted = false;
      this.messagePopup.showPopup();
    }
  }

  public actMemberControlFormSubmit(e: Event) {
    e.preventDefault();
    try {
      this.controllerToModel3();

      if (this.model.RefNoUsedBefore.length < 16 || this.model.PlateUsedBefore.length < 5) {
        this.messagePopup.showPopup();
        return;
      }

      if (this.isSubmitted)
        return;

      if (this.actMemberControlForm.valid) {
        this.isSubmitted = true;
        var promise = this.commonService.actMemberControl(this.dataService, this.model);
        promise.then((result) => {
          this.isSubmitted = false;
          this.model.ErrorCode = result.ErrorCode;
          this.model.ErrorMessage = result.ErrorMessage;
          this.model.IsRegistered = result.IsRegistered;
          this.model.LoginSuccess = result.LoginSuccess;
          this.model.IsActUserControlOk = result.IsActUserControlOk;

          if (!this.showErrorMessages()) {
            if (this.model.LoginSuccess && this.model.IsRegistered && this.model.IsActUserControlOk) {
              this.sessionService.authenticated = true;
              this.sessionService.forceTimeout = false;
              this.commonService.isLoggedin.next(true);
              this.commonService.loggedUserName.next(this.model.MemberName + " " + this.model.MemberSurname);
              this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
            }
            else {
              this.showErrorMessages();
            }
          }
        });
      }
    } catch (e) {
      this.isSubmitted = false;
      this.messagePopup.showPopup();
    }
  }

  public cancel(e: Event) {
    e.preventDefault();
    this.callLogOut();
  }

  callLogOut() {
    this.commonService.logOut(true);
    this.router.navigateByUrl(SharedModel.PageName_Landing);
  }

  public openErrorPopup(errorMessage: string) {
    this.popUpMessage = this.model.ErrorMessage;
    this.messagePopup.showPopup();
    (onMessageAccepted) => this.callLogOut();
  }

  public sendSMS(e: Event) {
    e.preventDefault();
    this.startTimer();
    this.model.SMSKey = null;
    var promise = this.commonService.applyLogin(this.dataService, this.model);
    promise.then((result) => {
      this.model.ErrorCode = result.ErrorCode;
      this.model.ErrorMessage = result.ErrorMessage;
      this.wrongSmsKey = false;

      if (this.showErrorMessages()) {
        /*SMS phase*/
        this.showSMSForm();
      } else {
        this.startTimer();
      }
    });
  }

  private unMask(value: string): any {

    return value.replace(/\D/g, "");
  }

  private controllerToModel() {
    //process controll values and pass to model (like unmask the input values)
    this.model.TCKN = this.loginForm.get('identity').value;
    this.model.GsmNo = this.unMask(this.loginForm.get('telephoneNumber').value);
    this.model.MaskedGsm = this.loginForm.get('telephoneNumber').value;
  }

  private controllerToModel2() {
    this.model.MemberName = this.newMemberForm.get('memberName').value;
    this.model.MemberSurname = this.newMemberForm.get('memberSurname').value;
    this.model.BirthDate = this.newMemberForm.get('birthdate').value;;
  }

  private controllerToModel3() {
    this.model.RefNoUsedBefore = this.actMemberControlForm.get('referansNo').value;
    this.model.PlateUsedBefore = this.actMemberControlForm.get('plateNumber').value;
  }

  public showErrorMessages(): boolean {
    if (this.model.ErrorCode != -1 /*error dönmüş*/) {
      //sms yanlış girildi. hata mesajı, textbox'ın üstünde durucak
      if (this.model.ErrorCode == 3) {
        this.wrongSmsKey = true;
        this.wrongSmsErrorMessage = this.model.ErrorMessage;
      }
      this.popUpMessage = this.model.ErrorMessage;
      this.messagePopup.showPopup();
      return true;
    }

    return false;

  }

  public showMessagePopUp(message: string) {
    this.popUpMessage = message;
    this.messagePopup.showPopup();
  }

  timeLeft: number = 120;
  interval;
  startTimer() {
    this.timeLeft = 120;
    this.isSmsReSendBtnActive = false;
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        if (this.timeLeft == 1)
          this.isSmsReSendBtnActive = true;

        this.timeLeft--;

      } else {

      }
    }, 1000)
  }

  public showLoginForm() {
    this.loginForm.reset();
    this.model.SMSKey = null;
    this.model.WrongCaptchaEntry = false;

    this.isLoginFormActive = true;
    this.isCaptchaActive = false;
    this.isSmsFormActive = false;
  }

  public showCaptchaForm() {
    this.isLoginFormActive = false;
    this.isCaptchaActive = true;
    this.isSmsFormActive = false;
  }

  public showSMSForm() {
    this.isLoginFormActive = false;
    this.isCaptchaActive = false;
    this.isSmsFormActive = true;
    //TODO: FOR TEST
    if (this.actAsTst)
      this.model.SMSKey = '123456';
    else
      this.model.SMSKey = '';
  }

  public showNewMemberForm() {
    this.loginForm.reset();
    this.model.SMSKey = null;
    this.model.WrongCaptchaEntry = false;

    this.isLoginFormActive = false;
    this.isCaptchaActive = false;
    this.isSmsFormActive = false;
    this.isActMemberControlFormActive = false;
    this.isNewMemberFormActive = true;
  }

  public showActMemberControlForm() {
    this.loginForm.reset();
    this.model.SMSKey = null;
    this.model.WrongCaptchaEntry = false;

    this.isActMemberControlFormActive = true;
    this.isLoginFormActive = false;
    this.isCaptchaActive = false;
    this.isSmsFormActive = false;
    this.isNewMemberFormActive = false;

  }

  openInformationDocument() {
    let docList = this.commonService.publicDocList;
    if (docList) {
      this.openDocumentId = docList.ViewModelList[0].DocumentId;
      this.docTitle = docList.ViewModelList[0].Name;
      this.openDocumentList = docList.ViewModelList[0].DocContentList;
      this.documentOpen = true;
      this.isOpenDocument1 = true;
    }
  }

  openTermOfUseDocument() {
    let docList = this.commonService.publicDocList;
    if (docList) {
      this.openDocumentId = docList.ViewModelList[1].DocumentId;
      this.docTitle = docList.ViewModelList[1].Name;
      this.openDocumentList = docList.ViewModelList[1].DocContentList;
      this.documentOpen = true;
      this.isOpenDocument2 = true;
    }
  }

  closeDocument(title: any) {
    this.documentOpen = false;
  }
  cancelDocument(title: any) {
    this.documentOpen = false;
  }

  getRandomDigit(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  resetModel() {
    this.model.LoginSuccess = null;
    this.model.SmsSent = null;
    this.model.ErrorCode = null;
    this.model.ErrorMessage = null;
    this.model.IsRegistered = null;
    this.model.NeedExtraInfo = null;
    this.model.MemberName = null;
    this.model.MemberSurname = null;
    this.model.SMSKey = null;
    this.model.TcknDenendi = null;
    this.model.ActAsTst = null;
    this.model.UseKps = null;
    this.model.ShowCaptcha = null;
    this.model.CaptchaModel = null;
    this.model.WrongCaptchaEntry = null;
    this.model.RefNoUsedBefore = null;
    this.model.PlateUsedBefore = null;
    this.model.IsActUserControlOk = null;
    this.model.TCKN = null;
    this.model.GsmNo = null;
    this.model.MaskedGsm = null;
  }

  // FORTEST
  generateTcNo() {
    var digits = [];
    var tcNo = "";
    digits[0] = this.getRandomDigit(1, 9);
    for (var i = 1; i < 9; i++) {
      digits[i] = this.getRandomDigit(0, 9);
    }
    digits[9] = ((digits[0] + digits[2] + digits[4] + digits[6] + digits[8]) * 7 -
      (digits[1] + digits[3] + digits[5] + digits[7])) % 10;
    digits[10] = (digits[0] + digits[1] + digits[2] + digits[3] + digits[4] + digits[5] +
      digits[6] + digits[7] + digits[8] + digits[9]) % 10;

    tcNo = digits[0].toString() + digits[1].toString() + digits[2].toString() + digits[3].toString() +
      digits[4].toString() + digits[5].toString() + digits[6].toString() + digits[7].toString() +
      digits[8].toString() + digits[9].toString() + digits[10].toString();

    this.loginForm.get('identity').setValue(tcNo);
  }

  onPasteFirmReferenceEntry(event: ClipboardEvent) {
    const pastedText = event.clipboardData.getData('text');
    const regex = /QN\d{14}/;
    const match = pastedText.match(regex);

    if (match) {
      this.model.RefNoUsedBefore = match[0]; 
    } else {
      this.model.RefNoUsedBefore = ""; 
    }
    this.actMemberControlForm.controls['referansNo'].setValue(this.model.RefNoUsedBefore);
    return;
  }

  getTelephoneNumberValidationText() {
    if (this.loginForm.controls.telephoneNumber.invalid && this.loginForm.controls.telephoneNumber.touched) {
      if (this.loginForm.controls.telephoneNumber.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

  getTcknValidationText() {
    if (this.loginForm.controls.identity.invalid && this.loginForm.controls.identity.touched) {
      if (this.loginForm.controls.identity.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

  getMemberNameValidationText() {
    if (this.newMemberForm.controls.memberName.invalid && this.newMemberForm.controls.memberName.touched) {
      if (this.newMemberForm.controls.memberName.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

  getMemberSurnameValidationText() {
    if (this.newMemberForm.controls.memberSurname.invalid && this.newMemberForm.controls.memberSurname.touched) {
      if (this.newMemberForm.controls.memberSurname.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

  getMemberBirthDateValidationText() {
    if (this.newMemberForm.controls.birthdate.invalid && this.newMemberForm.controls.birthdate.touched) {
      if (this.newMemberForm.controls.birthdate.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

  getReferansNoValidationText() {
    if (this.actMemberControlForm.controls.referansNo.invalid && this.actMemberControlForm.controls.referansNo.touched) {
      if (this.actMemberControlForm.controls.referansNo.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

  getPlateNoValidationText() {
    if (this.actMemberControlForm.controls.plateNumber.invalid && this.actMemberControlForm.controls.plateNumber.touched) {
      if (this.actMemberControlForm.controls.plateNumber.errors['required']) {
        return 'Zorunlu alan.';
      }
      else {
        return 'Eksik veya hatalı giriş.';
      }
    }
  }

}
